// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__Vhh_V","cell":"ColumnAccessor_cell__2JYr2","firstCellAccent":"ColumnAccessor_firstCellAccent__KJhPY"};